export default __webpack_public_path__ + "static/media/logo-big.c15e9aab.jpg";